import './pages.css';

const AboutUsDentistry = () => {
    return (
        <div className="page about-us-dentistry">
            {/* Hero Section */}
            <section className="dentistry-hero-section">
                <div className="dentistry-hero-content">
                    <h1>Digital Dentistry</h1>
                    <p className="dentistry-tagline">Cutting-Edge Technology for Superior Results</p>
                    <p className="dentistry-statement">
                        As the dental industry continues to advance, AbELab is your resource for
                        digitally designed and fabricated restorations at the forefront of innovation.
                    </p>
                </div>
            </section>

            {/* Main Content Section */}
            <section className="dentistry-content-section">
                <div className="content-container">
                    {/* Introduction Card */}
                    <div className="dentistry-intro-card">
                        <p>
                            We have made all the investments that are crucial for keeping our lab on the cutting-edge
                            of technology. Our dedication to digital dentistry is clear in not only our workflow,
                            restorations, and equipment, but also in our commitment to continuing education that helps
                            clinicians embrace these modern changes to the industry.
                        </p>
                    </div>

                    {/* Digital Advantages */}
                    <div className="section-header">
                        <h2>The Digital Advantage</h2>
                        <p className="section-description">
                            Discover how digital dentistry transforms precision, efficiency, and patient satisfaction
                        </p>
                    </div>

                    <div className="digital-features">
                    
                        <div className="feature-card">
                            <div className="feature-icon">✨</div>
                            <h3>Superior Esthetics</h3>
                            <p>
                                Advanced CAD/CAM technology enables us to create restorations with
                                exceptional detail and natural-looking results.
                            </p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">⚡</div>
                            <h3>Streamlined Workflow</h3>
                            <p>
                                Digital impressions and design processes reduce turnaround time while
                                improving communication and case tracking.
                            </p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">🔬</div>
                            <h3>Advanced Materials</h3>
                            <p>
                                Digital fabrication unlocks access to the latest high-performance
                                materials for strength and longevity.
                            </p>
                        </div>

                    </div>

                    {/* Call to Action */}
                    <div className="dentistry-cta">
                        <h2>Discover the Digital Difference</h2>
                        <p>
                            Our team highly values the precision, fit, and esthetics that are afforded by digital dentistry.
                            We invite you to discover the digital difference today and partner with AbELab for your
                            cutting-edge dental laboratory needs.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUsDentistry;
